module.exports = __webpack_public_path__ + "img/bg-achieve.3284afcb.png";